import { IconPropsType } from '..';

export const IncomeIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M5.90692 6.4302C5.90692 6.1146 6.03229 5.81193 6.25545 5.58877C6.47861 5.36561 6.78128 5.24023 7.09688 5.24023H14.2367C14.5523 5.24023 14.8549 5.36561 15.0781 5.58877C15.3013 5.81193 15.4266 6.1146 15.4266 6.4302V13.57C15.4266 13.8856 15.3013 14.1882 15.0781 14.4114C14.8549 14.6346 14.5523 14.7599 14.2367 14.7599C13.9211 14.7599 13.6184 14.6346 13.3952 14.4114C13.1721 14.1882 13.0467 13.8856 13.0467 13.57V9.33966L7.93581 14.4149C7.82486 14.525 7.69329 14.6123 7.54863 14.6716C7.40396 14.7309 7.24903 14.7612 7.09268 14.7606C6.7769 14.7595 6.4745 14.633 6.25201 14.4089C6.14184 14.2979 6.0546 14.1664 5.99528 14.0217C5.93595 13.8771 5.9057 13.7221 5.90626 13.5658C5.90737 13.25 6.03388 12.9476 6.25796 12.7251L11.401 7.62016H7.09688C6.78128 7.62016 6.47861 7.49479 6.25545 7.27163C6.03229 7.04847 5.90692 6.7458 5.90692 6.4302Z"
      fill="#31B335"
    />
  </svg>
);
